"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationFlight = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Sub_1 = require("../../Page/Title/Sub");
const Flight_1 = require("../../Tabs/Flight");
require("./index.scss");
const className = 'reservation-flight';
class ReservationFlight extends react_1.default.PureComponent {
    render() {
        const { activeTab, comment, description, modificators, tabs, text, } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'airplane', text: text, description: description }),
            react_1.default.createElement(Flight_1.FlightTabs, { activeTab: activeTab, tabs: tabs }),
            comment && (react_1.default.createElement("p", { className: `${className}__comment` }, comment))));
    }
}
exports.ReservationFlight = ReservationFlight;
ReservationFlight.defaultProps = {
    activeTab: 3,
};
//# sourceMappingURL=index.js.map